import React, { type FunctionComponent } from 'react'
// Approved by the IPP team.
// eslint-disable-next-line @retailer-platform/no-restricted-imports
import { RangeCalendar, type RangeCalendarProps } from '@mantine/dates'
import { colors, fontSize, fontWeight } from '../../../foundation'
import { type DateRange } from '../DateRangePicker'

interface DateRangePickerCalendarProps {
  dates: DateRange
  onChange: (dates: [Date, Date]) => void
  excludeDate?: RangeCalendarProps['excludeDate']
}

export const DateRangePickerCalendar: FunctionComponent<DateRangePickerCalendarProps> = ({
  dates,
  onChange,
  excludeDate,
}) => (
  <RangeCalendar
    data-testid="date-range-picker-calendar"
    firstDayOfWeek="sunday"
    dayStyle={(date, modifiers) => {
      let modifierOverrideStyles = {}

      if (modifiers.selectedInRange) {
        modifierOverrideStyles = {
          backgroundColor: colors.PRIMARY.REGULAR,
          color: 'white',
        }
      } else if (modifiers.inRange) {
        modifierOverrideStyles = {
          color: colors.GRAYSCALE.X70,
        }
      } else if (modifiers.disabled) {
        modifierOverrideStyles = {
          color: colors.GRAYSCALE.X30,
        }
      }

      return {
        ...modifierOverrideStyles,
      }
    }}
    allowLevelChange={false}
    value={[dates.start, dates.end]}
    onChange={onChange}
    amountOfMonths={2}
    allowSingleDateInRange
    styles={{
      calendarBase: { maxWidth: '560px' },
      calendarHeaderLevel: {
        fontWeight: fontWeight.SEMIBOLD,
        fontSize: fontSize.X15,
      },
      cell: {
        border: `1px solid ${colors.GRAYSCALE.X20}`,
      },
      day: {
        borderRadius: '0px',
        fontSize: fontSize.X12,
        fontWeight: 600,
        color: colors.GRAYSCALE.X70,
        '&:hover': {
          background: colors.GRAYSCALE.X50,
          color: 'white',
        },
        '&[data-in-range]': {
          backgroundColor: colors.SUCCESS.LIGHT,
        },
        '&[data-in-range]:hover': {
          color: colors.GRAYSCALE.X70,
          backgroundColor: colors.GRAYSCALE.X20,
        },
        '&[data-selected]': {
          backgroundColor: colors.PRIMARY.REGULAR,
          color: 'white',
        },
      },
      weekday: {
        color: colors.GRAYSCALE.X70,
        fontSize: fontSize.X12,
      },
    }}
    excludeDate={excludeDate}
    // no weekend days because we don't want them styled differently from weekdays
    weekendDays={[]}
  />
)
